// extracted by mini-css-extract-plugin
export default {"nav":"gxOt9nlM1LcOC2GxzQbg"};